<div class="back-button-container">
  <a routerLink="/" class="back-button">↩ Back</a>
</div>
<section class="psihoterapy-page">
  <div class="psihoterapy-container">
    <article class="psihoterapy-card">
      <h1 class="psihoterapy-title">Terapie individuală cu adulți și adolescenți</h1>
      <div class="psihoterapy-content">
        <div class="feature-item" [innerHTML]="contents1"></div>
      </div>
    </article>
  </div>
</section>